/**
 * Author:Murugaeswari
 * Modified by:kani,Murugaeswari
 * Modified Date: 2025-05-05
 */
// PricingPlans.js
import React, { useRef, useEffect, useState } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody
} from "reactstrap";


// import * as url from "../../helpers/url_helper";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { Link, useNavigate,useParams } from "react-router-dom";
import './PricingPlans.css';
import classnames from 'classnames';
import { getLoggedInUser } from "../../../helpers/fakebackend_helper"
import * as url from "../../../../src/helpers/url_helper";
import Spinners from "../../../components/Common/Spinner";

function MySubscription({value}) {

  const navigate = useNavigate();
   const { sid } = useParams();
  
   const [isLoading, setLoading] = useState(false);
   const user = getLoggedInUser();
  const [activeTab, setActiveTab] = useState('1');
  const [activePlans, setActivePlans] = useState([]);
  const [expiredPlans, setExpiredPlans] = useState([]);
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
   useEffect(() => {
    if (value) {
      getSubscribedList(value)
    }
  }, [value]);
 useEffect(() => {
   
      getSubscribedList()
    
  }, []);
 
  const getSubscribedList = async (flagval = 0) => {
     setLoading(true);
    const data = {
      user_id: Number(user.uid),
      stid: Number(sid),
      flag:flagval
    }
   
    const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
    try {
      const response = await axios.post(url.BASE_URL + 'student/getSubscribedList', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
         setLoading(false);
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }
     

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
         setLoading(false);
        const refresh = await getRefreshToken();
        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await getSubscribedList();
          }
        }
      }


      if (response?.data?.body?.list) {
        var activeList = response?.data?.body?.list.filter(item => item?.status_id === 1);
        setActivePlans(activeList)
        var expiredList = response?.data?.body?.list.filter(item => item?.status_id === 8);
        setExpiredPlans(expiredList)
         setLoading(false);
      } else {
        setLoading(false);
        // toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      setLoading(false);
      // Handle error
      console.error("student detailsAPI Error:", error);
    }
  }
  return (
    <div>

      <div className="pricing-wrapper card" style={{ padding: '16px', background: '#fff !important' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '16px' }}>
  <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
    My Subscription
  </div>
 
</div>
         {  isLoading?  <Spinners setLoading={setLoading} />:'' }

        <Nav tabs className="nav-tabs-custom">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' })}
              onClick={() =>
                { 
                  toggle('1')
                  getSubscribedList()
                }}
            >
              Subscriptions
            </NavLink>
          </NavItem>
         

        </Nav>

        <TabContent activeTab={activeTab} className="p-3">
          <TabPane tabId="1">

            <div className="row" style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
               {expiredPlans && expiredPlans.length == 0 && activePlans && activePlans.length == 0 &&
                <div className="col-12 col-md-6 col-lg-3 mb-4 d-flex">
                  
                      <div style={{ fontSize: '14px', fontStyle: 'italic' }}>No subscriptions found.</div>
                   
                  </div>

              }
              {activePlans.map((item) => (
                <div key={item.subscription_id} className="col-12 col-md-6 col-lg-6 mb-4 d-flex">
                  <Card className="w-100 ">
                  
                    <CardBody className="subscription-card">
                      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{item.plan_name}</div>
                       <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-12">
                        <div className="font-size-13" title={item.category_plan} style={{maxWidth:'270px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingTop: '4px',paddingBottom:'4px' ,color:'darkgoldenrod',fontWeight:'500'}}>
                        {item?.category_plan}
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-5">
                          <p style={{ color: 'green' }}>
                            <i className="mdi mdi-currency-inr" />
                            {item.amount} | {item.validity}
                          </p>
                        </div>
     
                      </div>

                      <p style={{ borderTop: '1px solid #000', paddingTop: '16px' }}>
                        <i className="mdi mdi-check-circle-outline me-2" />
                        No. of Tests Attempted: <strong>{item.test_attempted}</strong> / {item.no_of_test}
                      </p>

                      <p>
                        <i className="mdi mdi-grid me-2" />
                        Questions per Test: {item.total_questions}
                      </p>

                      <p>
                        <i className="mdi mdi-calendar me-2" />
                        Subscribed on:{item.start_at}
                      </p>
                      <p style={{ color: 'orange' }} className="expire-bold">
                        <i className="mdi mdi-alarm me-2" />
                        {item.expire_text}: {item.expired_at}
                      </p>

                      {/* <button className="btn btn-primary" onClick={() =>   navigate("/onlinetest")}>SELECT</button> */}
                    </CardBody>
                  </Card>  </div>
              ))}
               {expiredPlans.map((item) => (
                <div key={item.subscription_id} className="col-12 col-md-6 col-lg-6 mb-4 d-flex">
                  <Card className="w-100 ">
                    <CardBody className="subscription-card">
                      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{item.plan_name}</div>
                      <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-12">
                        <div className="font-size-14" title={item.category_plan} style={{maxWidth:'270px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingTop: '4px',paddingBottom:'4px' ,color:'darkgoldenrod',fontWeight:'500'}}>
                        {item?.category_plan}
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ paddingTop: '0px' }}>
                        <div className="col-md-5">
                          <p style={{ color: 'green' }}>
                            <i className="mdi mdi-currency-inr" />
                            {item.amount} | {item.validity}
                          </p>
                        </div>
                      </div>

                      <p style={{ borderTop: '1px solid #000', paddingTop: '16px' }}>
                        <i className="mdi mdi-check-circle-outline me-2" />
                        No. of Tests Attempted: <strong>{item.test_attempted}</strong> / {item.no_of_test}
                      </p>

                      <p>
                        <i className="mdi mdi-grid me-2" />
                        Questions per Test: {item.total_questions}
                      </p>

                      <p>
                        <i className="mdi mdi-calendar me-2" />
                        Subscribed on:{item.start_at}
                      </p>

                      <p style={{ color: 'red' }} className="expire-bold">
                        <i className="mdi mdi-alarm me-2" />
                         {item.expire_text}: {item.expired_at}
                      </p>

                    </CardBody>
                  </Card>  </div>
              ))}
            </div>



          </TabPane>

      


        </TabContent>

      </div>
    </div>


  );
}
export default MySubscription;